<style src="./BidResume.scss" lang="scss"></style>
<template>
  <section class="bid-resume">
    <content-header path="Resultado">
      <li>
        <select
          class="selectcalendar"
          v-model="filters.month">
          <option
            v-for="(v, i) in filters.months"
            :key="i"
            :value="i + 1">
            {{ v }}
          </option>
        </select>
      </li>
      <li>
        <select
          class="selectcalendar"
          v-model="filters.year">
          <option
            v-for="(v, i) in filters.years"
            :key="i"
            :value="v">
            {{ v }}
          </option>
        </select>
      </li>
    </content-header>
    
    <section class="row cards">
      <total-events
        class="col-3"
        :countTotal="countBid.countTotal"
        :participated="countBid.participated"
        :notParticipated="countBid.notParticipated" />

      <in-progress-event
        class="col-3"
        :countInProgress="inProgress.countInProgress"
        :waitingMode="inProgress.waitingMode" />

      <month-events
        class="col-3"
        :month="filters.month"
        :year="filters.year"
        :monthParticipated="countBid.monthParticipated"
        :monthNotParticipated="countBid.monthNotParticipated" />

      <count-values
        class="col-3"
        :month="filters.month"
        :year="filters.year"
        :totalItems="countValues.totalItems"
        :countParticipatedEstimated="countValues.countParticipatedEstimated"
        :quotedCountItems="countValues.quotedCountItems"
        :quotedTotal="countValues.quotedTotal"
        :wonTotalItems="countValues.wonTotalItems"
        :wonTotal="countValues.wonTotal"
        :costWinnerTotal="countValues.costWinnerTotal"
        :isWaitingLoad="countValues.isWaintingLoad" />

    </section>

    <section class="row">
      <div class="col-12 container-area">
        <div class="filters">
          <input
            type="text"
            v-model="searchText"
            v-debounce="300"
            @debounced="filterByText"
            placeholder="Busque por cliente ou preção"
            class="textbox" />
          <select
            class="actualstage"
            v-model="filters.actualStage">
            <option value="in-progress">EM ANDAMENTO</option>
            <option value="with-result">RESULTADO</option>
            <option value="just-finished">FINALIZADO</option>
          </select>
          <select
            class="actualstage"
            v-model="filters.byBalanceStatus">
            <option value="all">TODOS OS MARKUPS</option>
            <option value="positive">MARKUP POSITIVO</option>
            <option value="nobalance">SEM MARKUP</option>
            <option value="error">MARKUP COM ERRO</option>
          </select>
        </div>

        <div
          v-show="filteredList.length === 0"
          class="empty-container">
          <icon-empty class="empty" />
          <span class="title">Não encontramos nenhum resultado</span>
        </div>

        <ul
          v-show="filteredList.length > 0"
          class="bidresume-container">
          <li
            v-for="(bidResume, bidResumeIdx) in filteredList"
            :key="bidResumeIdx"
            class="itemrow">
            <div class="date">
              <span class="date">{{ bidResume.date | getDate }}</span>
              <span class="month">{{ bidResume.date | getMonth }}</span>
              <span class="year">{{ bidResume.date | getYear }}</span>
            </div>
            <div class="eventdetail">
              <span
                @click="goToMap(bidResume)"
                class="clientname">{{ bidResume.clientName }}</span>
              <div class="details">
                <span class="modality">{{ bidResume.modality }}</span>
                <span class="identification">{{ bidResume.identification }}</span>
                <span class="altcode" title="Código Alternativo">{{ bidResume.alternativeCode }}</span>
              </div>
            </div>
            <div class="result estimated">
              <div class="values">
                <span class="title">ESTIMADO</span>
                <span class="label"><small>R$</small> {{ bidResume.estimatedPrice | CurrencyBR('-----') }}</span>
              </div>
              <div class="values">
                <span class="title">QT ITENS</span>
                <span class="label">{{ bidResume.countItems | DecimalNumber }}</span>
              </div>
            </div>
            <div class="result quoted">
              <div class="values">
                <span class="title">QT COTADOS</span>
                <span class="label">{{ bidResume.quantityQuoted | DecimalNumber }}</span>
              </div>
              <div class="values">
                <span class="title">QT GANHO</span>
                <span class="label">{{ bidResume.quantityWin | DecimalNumber }}</span>
              </div>
            </div>
            <div class="costs">
              <div class="values">
                <span class="title">CUSTO COTADO</span>
                <span class="label primary"><small>R$</small> {{ bidResume.totalQuotedCost | CurrencyBR('-----') }}</span>
              </div>
              <div class="values">
                <span class="title">CUSTO GANHO</span>
                <span class="label"><small>R$</small> {{ bidResume.totalCost | CurrencyBR('-----') }}</span>
              </div>
              <div class="values">
                <span class="title">TOTAL VENDIDO</span>
                <span class="label"><small>R$</small> {{ bidResume.totalSold | CurrencyBR('-----') }}</span>
              </div>
            </div>
            <div class="result usage">
              <span class="title">APROVEITAMENTO</span>
              <div class="values">
                <div class="detail">
                  <span class="title">COTADOS</span>
                  <span class="value">{{ calculateUsage(bidResume.countItems, bidResume.quantityQuoted) }} <small>%</small></span>
                </div>
                <div class="detail">
                  <span class="title">GANHO</span>
                  <span class="value">{{ calculateUsage(bidResume.quantityQuoted, bidResume.quantityWin) }} <small>%</small></span>
                </div>
              </div>
            </div>
            <div class="result balance">
              <div class="values">
                <span class="title">MARKUP</span>
                <div class="labelcontainer">
                  <span class="label">{{ bidResume.balance }} <small>%</small></span>
                </div>
              </div>
            </div>
            <div class="result stage">
              <span class="label">{{ bidResume.actualStage }}</span>
            </div>
          </li>
        </ul>
      </div>
    </section>
  </section>
</template>

<script>
import moment from 'moment'
import { CurrencyBR, DecimalNumber } from '@/components/primitives/helpers/filters'
import ContentHeader from '@/components/foundation/content-header/ContentHeader'
import TotalEvents from '../components/total-events/TotalEvents'
import MonthEvents from '../components/month-events/MonthEvents'
import InProgressEvent from '../components/in-progress-events/InProgressEvent'
import CountValues from '../components/count-values/CountValues'
import {DebounceDirective} from '@/components/primitives/helpers/debounce/Debounce'
import { IconEmpty } from '@/components/primitives/icons'

const MONTHS = ['JANEIRO', 'FEVEREIRO', 'MARÇO', 'ABRIL', 'MAIO', 'JUNHO', 'JULHO', 'AGOSTO', 'SETEMBRO', 'OUTUBRO', 'NOVEMBRO', 'DEZEMBRO']
const firstYear = 2019

export default {
  name: 'BidResume',
  components: {
    ContentHeader,
    TotalEvents,
    MonthEvents,
    InProgressEvent,
    CountValues,
    IconEmpty
  },
  directives: {
    debounce: DebounceDirective
  },
  data () {
    return {
      filters: {
        month: '',
        year: '',
        actualStage: 'just-finished',
        years: [],
        months: MONTHS,
        byBalanceStatus: 'all',
        searchText: ''
      },
      searchText: '',
      bidResumes: [],
      countBid: {
        countTotal: 0,
        participated: 0,
        notParticipated: 0,
        monthParticipated: 0,
        monthNotParticipated: 0
      },
      inProgress: {
        countInProgress: 0,
        waitingMode: 0
      },
      countValues: {
        isWaintingLoad: false,
        totalItems: 0,
        countParticipatedEstimated: 0,
        quotedCountItems: 0,
        quotedTotal: 0,
        wonTotalItems: 0,
        wonTotal: 0,
        costWinnerTotal: 0
      }
    }
  },
  computed: {
    filteredList () {
      const actualFilterStage = this.filters.actualStage
      const actualFilterBalance = this.filters.byBalanceStatus
      const actualFilterText = this.filters.searchText
      const filtered = this.bidResumes.filter(item => this.filterList({
        item,
        actualFilterStage,
        actualFilterBalance,
        actualFilterText
      }))
      return filtered
    },
    textMonth () {
      return MONTHS[Number(this.month) - 1]
    }
  },
  beforeMount () {
    this.defineCalendar()
  },
  mounted () {
    this.loadBidResume()
    this.loadCountBid()
    this.loadInProgress()
    this.loadCountValues()
  },
  filters: {
    getDate: (v) => v && moment(v).format('DD'),
    getMonth: (v) => v && moment(v).format('MMM').toUpperCase(),
    getYear: (v) => v && moment(v).format('YYYY'),
    CurrencyBR,
    DecimalNumber
  },
  watch: {
    'filters.month' () {
      this.loadCountValues()
      this.loadBidResume()
      this.loadCountBid()
    },
    'filters.year' () {
      this.loadCountValues()
      this.loadBidResume()
      this.loadCountBid()
    }
  },
  methods: {
    async loadBidResume () {
      try {
        // const distributorId = this.$store.getters['Distributors/DEFAULT_DISTRIBUTOR_ID']
        const payload = {
          // distributorId,
          month: Number(this.filters.month),
          year: Number(this.filters.year)
        }

        const bidResumes = await this.$store.dispatch('Dashboard/BID_RESUME', payload)
        if (!bidResumes.success) { this.bidResumes = [] }

        const computedValues = this.computeValues(bidResumes.bidResume)
        this.bidResumes = computedValues
      } catch (error) {
        return Error(error)
      }
    },
    async loadCountBid () {
      try {
        const params = {
          month: Number(this.filters.month),
          year: Number(this.filters.year)
        }
        const { countBid } = await this.$store.dispatch('Dashboard/COUNT_BID', { params })
        if (!countBid) {
          this.countBid = {
            countTotal: 0,
            participated: 0,
            notParticipated: 0,
            monthParticipated: 0,
            monthNotParticipated: 0
          }
        } else {
          this.countBid = countBid
        }
      } catch (error) {
        return Error(error)
      }
    },
    async loadInProgress () {
      try {
        const { inProgress } = await this.$store.dispatch('Dashboard/IN_PROGRESS')
        if (!inProgress) {
          this.inProgress = {
            countInProgress: 0,
            waitingMode: 0
          }
        } else {
          this.inProgress = inProgress
        }
      } catch (error) {
        return Error(error)
      }
    },
    async loadCountValues () {
      this.countValues.isWaintingLoad = true
      try {
        const distributorId = this.$store.getters['Distributors/DEFAULT_DISTRIBUTOR_ID']
        const params = {
          distributorId,
          month: Number(this.filters.month),
          year: Number(this.filters.year)
        }

        const { countValues } = await this.$store.dispatch('Dashboard/COUNT_VALUES', params)
        if (!countValues) {
          this.countValues = {
            totalItems: 0,
            countParticipatedEstimated: 0,
            quotedCountItems: 0,
            quotedTotal: 0,
            wonTotalItems: 0,
            wonTotal: 0,
            costWinnerTotal: 0
          }
        } else {
          this.countValues.totalItems = countValues.totalItems
          this.countValues.countParticipatedEstimated = countValues.countParticipatedEstimated
          this.countValues.quotedCountItems = countValues.quotedCountItems
          this.countValues.quotedTotal = countValues.quotedTotal
          this.countValues.wonTotalItems = countValues.wonTotalItems
          this.countValues.wonTotal = countValues.wonTotal
          this.countValues.costWinnerTotal = countValues.costWinnerTotal
        }
      } catch (error) {
        return Error(error)
      } finally {
        this.countValues.isWaintingLoad = false
      }
    },
    computeValues (bidResume) {
      const computed = bidResume.map(i => ({
        ...i,
        balance: this.calculateProfit(i.totalCost, i.totalSold)
      }))
      return computed
    },
    calculateProfit (cost, sold) {
      let profit = 0
      if (cost === 0 && sold === 0) {
        profit = 0
      } else if (!cost || !sold) {
        profit = 'ERRO!'
      } else {
        profit = (((sold * 100) / cost) - 100).toFixed(1)
      }
      return profit
    },
    calculateUsage (total, usage) {
      const profit = ((usage * 100) / total).toFixed()
      return isNaN(profit) ? '?' : profit
    },
    filterList ({ item, actualFilterStage, actualFilterBalance, actualFilterText }) {
      let isStageTrue = false
      let isBalanceTrue = true
      let isTextTrue = true
      switch (actualFilterStage) {
        case 'with-result':
          isStageTrue = item.actualStage === 'Resultado'
          break
        case 'in-progress':
          isStageTrue = item.actualStage === 'Em Andamento'
          break
        case 'just-finished':
          isStageTrue = item.actualStage !== 'Em Andamento' && item.actualStage !== 'Resultado'
          break
      }
      switch (actualFilterBalance) {
        case 'all':
          break
        case 'positive':
          isBalanceTrue = item.balance > 0
          break
        case 'nobalance':
          isBalanceTrue = item.balance <= 0
          break
        case 'error':
          isBalanceTrue = item.balance === 'ERRO!'
          break
      }
      if (actualFilterText && actualFilterText.trim() !== '') {
        const regEx = new RegExp(actualFilterText, 'i')
        const checkClient = regEx.test(item.clientName)
        const checkIdentification = regEx.test(item.identification)
        isTextTrue = checkClient || checkIdentification
      }
      return isStageTrue && isBalanceTrue && isTextTrue
    },
    defineCalendar () {
      const date = new Date()
      const actualMonth = date.getMonth()
      const actualYear = date.getFullYear()
      const listYears = []
      for (let year = firstYear; year <= actualYear; year++) {
        listYears.push(year)
      }
      this.filters.years = listYears
      this.filters.year = actualYear
      this.filters.month = actualMonth + 1
    },
    filterByText (t) {
      this.filters.searchText = this.searchText
    },
    goToMap (bidResume) {
      const eventId = bidResume.eventId
      const eventDetail = {
        _id: eventId,
        client: {
          shortName: bidResume.clientName
        },
        identification: bidResume.identification,
        modality: bidResume.modality,
        alternativeCode: ''
      }
      const routeParams = {
        eventId,
        eventDetail,
        newWindow: true,
        route: this.$router
      }
      this.$store.dispatch('Events/OPEN_EVENT', routeParams)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/dashboard/bid-resume/BidResume.vue